<template>
  <div class="main-container">
    <Content class="resume-container" title="期刊简介" :item="resume"></Content>
    <Notice title="征稿启事" :noticeItem="resume" v-if="resume.notice"></Notice>
  </div>
</template>

<script>
import Content from "../components/Content.vue";
import Notice from "../components/Notice.vue";
export default {
  components: {
    Content,
    Notice,
  },
  data() {
    return {
      resume: {},
    };
  },
  created() {
    this.bkDetailList({
      id: this.$route.query.id,
    });
  },
  methods: {
    async bkDetailList(data) {
      const resp = await this.$apis.hundredServe.bkDetailList(data);
      if (resp.periodicalInfo) {
        this.resume = resp.periodicalInfo;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  width: 895px;
  .resume-container {
    background-color: #fff;
    margin-bottom: 16px;
    // height: 644px;
    margin-right: 9px;
  }
}
</style>
